module.exports = __webpack_public_path__ + "img/sisda-pjt.b97b03b6.png";